"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCPLog = exports.initCPLog = void 0;
var hackle_1 = require("./hackle");
var mixpanel_1 = require("./mixpanel");
var flounder_1 = require("./flounder");
var events_1 = require("./events");
var utm_1 = require("./utm");
var flounderInstance;
var mixpanelInstance;
var hackleInstance;
var initCPLog = function (flounder_key, mixpanel_token, hackle_key, is_dev) {
    if (is_dev === void 0) { is_dev = true; }
    flounderInstance = new flounder_1.FlounderLog(flounder_key, is_dev);
    mixpanelInstance = new mixpanel_1.MixpanelLog(mixpanel_token);
    hackleInstance = new hackle_1.HackleLog(hackle_key);
};
exports.initCPLog = initCPLog;
var sendCPLog = function (key, data) {
    if (data === void 0) { data = {}; }
    try {
        (0, utm_1.setUTMCookies)();
        Object.assign(data, new events_1.CustomData());
        flounderInstance.push_events(key, data);
        mixpanelInstance.send(key, data);
        hackleInstance.send(key, data);
    }
    catch (e) {
        console.log(e);
    }
};
exports.sendCPLog = sendCPLog;
